module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00033.fe9bfc00.png";